<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-30 14:22:32
 * @FilePath: \gcp-fe\src\app\common-modules\layout\components\AppMain.vue
 * @Description: 
-->
<template>
  <section class="ccui-app-mains" v-loading="pageLoading" v-if="isRouterAlive">
    <keep-alive
      exclude="powerManageList,powerManageMaintain,powerManageMemberMaintain"
    >
      <router-view :key="key" />
    </keep-alive>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  // 用来刷新页面
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
    pageLoading() {
      return this.$store.state.app.pageLoading.pageLoadingStatus;
    }
  },
  methods: {
    // note 刷新页面的方法
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>
